<template>
  <div>
    <!-- 立即询价弹框 -->
    <Modal
      v-model="enquirytk"
      title="请确认询价信息:"
      :closable="false"
      footer-hide
      :mask-closable="false"
      class-name="vertical-center-modal"
      width="600px"
    >
      <div slot="header" class="h30">
        <div class="fz18">请确认询价信息&nbsp;:</div>
      </div>
      <p class="redxj mb10">询价有效期为8小时</p>
      <div class="flexj">
        <div class="seller">卖家&nbsp;:</div>
        <div style="flex: 1">{{ enquirydata.shopName }}</div>
      </div>
      <div class="flexj mt20">
        <div style="margin-right: 100px">询价商品&nbsp;:</div>
        <div style="flex: 1">
          <div class="mb5">
            <span style="margin-right: 20px" class="partypexj">{{
              enquirydata.typeName
            }}</span>
            <span
              >{{ enquirydata.carBrandName }}{{ enquirydata.stdNameJp
              }}{{ enquirydata.oeCode }}</span
            >
          </div>
          <div class="xishop">
            <li v-if="enquirydata.genuineGuarantee">
              <span class="iconfont icon-a-lujing153"></span>
              <p>正品保证</p>
            </li>
            <li v-if="enquirydata.technicalSupport">
              <span class="iconfont icon-a-ziyuan4"></span>
              <p>技术支持</p>
            </li>
            <li v-if="enquirydata.warrantyService">
              <span class="iconfont icon-a-ziyuan5"></span>
              <p>保修服务</p>
            </li>
            <li v-if="enquirydata.returnPromise">
              <span class="iconfont icon-a-ziyuan21"></span>
              <p>退换货承诺</p>
            </li>
          </div>
        </div>
      </div>
      <!-- 发货地 -->
      <div class="w122">
        <div class="mr100">发货地&nbsp;:</div>
        <div class="oe-p" @mouseleave="closeRelevance">
          <span
            v-if="enquirydata.shipCityStores&&enquirydata.shipCityStores.length > 0"
            class="w121"
            @mouseenter="getRelevance(enquirydata.partId, enquirydata)"
          >
            {{ enquirydata.shipCityStore.city }}
            {{ enquirydata.shipCityStore.name
            }}<i
              class="ivu-icon ivu-icon-ios-arrow-down"
              v-if="enquirydata.shipCityStores&&enquirydata.shipCityStores.length > 1"
            ></i>
            &nbsp;
            <i v-show="enquirydata.saleStatus == 1">
              {{
                enquirydata.shipCityStore.stock > 10
                  ? '10+'
                  : enquirydata.shipCityStore.stock
              }}/{{ enquirydata.unitId }}
            </i>
          </span>
          <div
            class="relevance"
            :tabIndex="1"
            v-if="enquirydata.shipCityStores&&enquirydata.shipCityStores.length > 1"
          >
            <div
              class="relevanceBox w33"
              :class="enquirydata.isShow ? 'show' : ''"
            >
              <p
                v-for="i in enquirydata.shipCityStores"
                :key="i.index"
                class="w22"
                :class="isCity === i.name ? 'isCityed' : ''"
                @click="checkCITY(i, enquirydata)"
              >
                {{ i.city }}
                {{ i.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="mt20">
        <span class="mr100">询价数量&nbsp;:</span>
        <InputNumber
          v-model="enquirynum"
          controls-outside
          :min="1"
          :precision="0"
          @on-change="changexjNum"
        ></InputNumber>
      </div>
      <div class="flexjz mt20">
        <Button
          type="error"
          :loading="loadeqd"
          @click="enquiryqd"
          class="bt10 mr50"
          >确定</Button
        >
        <Button type="error" @click="enquiryqx" class="bt10">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getenquiryqd } from '@/api/goodsList.js'
export default {
  data() {
    return {
      isCity: '',
      enquirytk: false, // 关闭弹框
      enquirynum: 1, // 询价数量
      loadeqd: false // 转圈
    }
  },
  props: {
    enquirydata: {
      type: Object
    }
  },
  methods: {
    // 弹框出来
    enquirytkc() {
      this.enquirytk = true
      this.enquirynum = 1
    },
    // 立即询价数量
    changexjNum(value) {
      console.log(value)
    },
    // 询价确定
    async enquiryqd() {
      this.loadeqd = true
      let data = {
        enquiryNum: this.enquirynum,
        offerTid: this.enquirydata.tenantId,
        offerTname: this.enquirydata.shopName,
        partId: this.enquirydata.partId
          ? this.enquirydata.partId
          : this.enquirydata.id,
        storeId: this.enquirydata.shipCityStore.storeId
      }
      const res = await getenquiryqd(data)
      this.loadeqd = false
      if (res.status) {
        this.$emit('enquirysx')
        this.enquirytk = false
        this.$Message.success('询价成功')
      }
    },
    // 询价取消
    enquiryqx() {
      this.enquirytk = false
    },
    async getRelevance(partId, item) {
      console.log(partId)
      console.log(item)
      this.isCity = item.shipCityStore.name
      this.$set(this.enquirydata, 'isShow', true)
    },
    // 关闭适用车型
    closeRelevance() {
      this.$set(this.enquirydata, 'isShow', false)
    },
    checkCITY(i, item) {
      console.log(i, item)
      this.isCity = i.name
      item.shipCityStore = i
      item.stock = i.stock
    }
  },
  watch: {
    enquirydata: function (newVal, oldVal) {
      console.log(newVal)
    }
  }
}
</script>
<style lang="less" scoped>
.redxj {
  color: #e90d0d;
}
.mb5 {
  margin-bottom: 5px;
}
.mb10 {
  margin-bottom: 10px;
}
.mt20 {
  margin-top: 20px;
}
// 这个是询价的
.xishop {
  display: flex;
  li {
    display: flex;
    margin-right: 15px;
    span {
      margin-right: 5px;
    }
    .icon-a-lujing153 {
      color: #47c460;
    }
    .icon-a-ziyuan5 {
      color: #ff8a24;
    }
    .icon-a-ziyuan4 {
      color: #24b4ff;
    }
    .icon-a-ziyuan21 {
      color: #ff3e3e;
    }
  }
}
.partypexj {
  border-radius: 2px;
  // height: 16px;
  line-height: 16px;
  font-size: 12px;
  text-align: center;
  background: #47c460;
  color: #ffffff;
  padding: 0 5px;
  font-family: 'Source Han Sans CN';
  // margin: 0 4px;
}
/deep/.ivu-input-number-input {
  text-align: center;
}
.flexj {
  display: flex;
}
.flexjz {
  display: flex;
  justify-content: center;
  align-items: center;
}
.bt10 {
  width: 100px;
  height: 35px;
}
.mr50 {
  margin-right: 50px;
}
.fz18 {
  font-size: 18px;
  font-weight: bold;
}
.mr100 {
  margin-right: 100px;
}
.seller {
  margin-right: 130px;
  width: 36px;
  // height: 21px;
}
/deep/.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
.w122 {
  margin-top: 20px;
  display: flex;
  .relevanceBox {
    text-align: left;
    // display: flex;
    padding: 4px 5px;
    position: absolute;
    top: 27px;
    // left: 52px;
    width: 130px;
    height: auto;
    border: 1px solid #e2e2e2;
    background-color: #fff;
    display: none;
    z-index: 99;
    overflow-y: auto;
    word-wrap: break-word;
    p {
      color: #9d9d9d;
      padding-left: 4px;
    }
    .w22 {
      font-size: 12px;
      color: #555555;
      cursor: pointer;
    }
    .isCityed {
      color: #377cf1;
    }
    span {
      font-size: 12px;
      line-height: 18px;
      font-weight: normal;
      color: #9d9d9d;
      // display: inline-block;
      padding-bottom: 6px;
    }
  }
  .w33 {
    border: none;
    background: #ffffff;
    box-shadow: 0px 6px 10px 1px rgba(104, 104, 104, 0.1);
    opacity: 1;
    top: 26px;
  }
  .show {
    display: block;
  }
}
.oe-p {
  // width: 130px;
  font-size: 12px;
  // padding-top: 10px;
  // padding-left: 4px;
  // color: #505050;
  position: relative;
  text-align: center;
  margin-left: 12px;
  .w121 {
    font-size: 14px;
    line-height: 26px;
    // color: #9d9d9d;
    cursor: pointer;
    display: inline-block;
    // padding: 3px 0;
    // border: 1px solid #e2e2e2;
    // border-radius: 2px 2px 2px 2px;
    // padding-bottom: 5px;
    .ivu-icon-ios-arrow-down {
      font-size: 16px;
      margin-left: 5px;
    }
  }
  .w122 {
    font-size: 12px;
    line-height: 26px;
    // color: #555555;
    cursor: pointer;
    // padding: 3px 0;
    // border: 1px solid #e2e2e2;
    // border-radius: 2px 2px 2px 2px;
    // padding-bottom: 5px;
    .ivu-icon-ios-arrow-down {
      font-size: 16px;
      margin-left: 5px;
    }
  }
  .w121:hover .ivu-icon-ios-arrow-down {
    transform: rotate(-180deg);
  }
  .ivu-icon-ios-arrow-down {
    font-size: 14px;
    cursor: pointer;
    transition: all 0.5s ease 0s;
  }
  .ivu-icon-ios-arrow-down:hover {
    transform: rotate(-180deg);
  }
  // .relevance {
  // cursor: pointer;
  // position: relative;
  // width: 20px;
  // margin: 0 5px;
  // img {
  //   width: 18px;
  //   height: 18px;
  // }
  // .icon-xiaodengpao {
  //   color: #b9b9b9;
  // }
  span {
    cursor: pointer;
  }
  .relevanceBox {
    text-align: left;
    // display: flex;
    padding: 4px 5px;
    position: absolute;
    top: 27px;
    // left: 52px;
    width: 130px;
    height: auto;
    border: 1px solid #e2e2e2;
    background-color: #fff;
    display: none;
    z-index: 99;
    overflow-y: auto;
    word-wrap: break-word;
    p {
      color: #9d9d9d;
      padding-left: 4px;
    }
    .w22 {
      font-size: 12px;
      color: #555555;
      cursor: pointer;
    }
    .isCityed {
      color: #377cf1;
    }
    span {
      font-size: 12px;
      line-height: 18px;
      font-weight: normal;
      color: #9d9d9d;
      // display: inline-block;
      padding-bottom: 6px;
    }
  }
  .w33 {
    border: none;
    background: #ffffff;
    box-shadow: 0px 6px 10px 1px rgba(104, 104, 104, 0.1);
    opacity: 1;
    top: 26px;
  }
  .show {
    display: block;
  }
  // }
}
</style>
